if (!window.customerFavouritesCarouselBound) {
  window.customerFavouritesCarouselBound = true;

  document.addEventListener('click', function (event) {
    var previous = event.target.closest('[data-customer-favourites-previous]');
    var next = event.target.closest('[data-customer-favourites-next]');
    var button = previous || next;
    if (!button) return;

    var carousel = button.closest('.customer-favourites__carousel');
    var track = carousel && carousel.querySelector('[data-customer-favourites-track]');
    if (!track) return;

    track.scrollBy({
      left: track.clientWidth * (previous ? -1 : 1),
      behavior: 'smooth',
    });
  });
}
